import api from '@/api';

import { API_BASE_URL } from '..';
const CONTROLLER_URL = `${API_BASE_URL}/matrices-whatsapp`;

import {
  MatrixWhatsappSettings,
  MatrixWhatsappSettingsCreate,
} from './MatrixWhatsappSettings.types';

export async function getMatrixWhatsappSettings() {
  const result = (await api.get(CONTROLLER_URL, {})) as unknown;

  return result as MatrixWhatsappSettings[];
}

export async function createMatrixWhatsappSettings(
  obj: MatrixWhatsappSettingsCreate,
) {
  const result = (await api.post(CONTROLLER_URL, obj)) as unknown;

  return result as MatrixWhatsappSettings;
}

export async function getByIdMatrixWhatsappSettings(id: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, {})) as unknown;

  return result as MatrixWhatsappSettings;
}

export async function updateMatrixWhatsappSettings(
  obj: MatrixWhatsappSettings,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result as MatrixWhatsappSettings;
}

export async function deleteMatrixWhatsappSettings(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}
